"use client"

import { CornerUpLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CornerUpLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CornerUpLeftIcon = component(Icon)({ as: CornerUpLeft })
